<script>
// Vue 3: il vecchio wrapper `SlotProps.js` (manipolava `componentOptions.propsData`
// dei vnode, API Vue 2 rimossa) è sostituito da una render function. Inietta
// `row`/`action` in ogni colonna slottata via `cloneVNode` e le rende dentro un <tr>,
// preservando lo stesso markup/comportamento (node="tr").
import { h, cloneVNode, Fragment } from 'vue';
import DataTableColumn from '@/components/table/DataTableColumn.vue';

// Lo slot può arrivare avvolto in un Fragment (es. dopo un re-render) oppure
// contenere nodi testo/commento: si appiattisce ricorsivamente tenendo solo i
// vnode di componente (le colonne).
const flattenColumns = (vnodes) => {
  const out = [];
  (vnodes || []).forEach((vnode) => {
    if (vnode.type === Fragment && Array.isArray(vnode.children)) {
      out.push(...flattenColumns(vnode.children));
    } else if (typeof vnode.type === 'object' || typeof vnode.type === 'function') {
      out.push(vnode);
    }
  });
  return out;
};

export default {
  name: 'TableRow',
  props: {
    allowSelection: { type: Boolean, default: false },
    rowAction: { type: Function, default: null },
    columns: { type: Array, default: () => [] },
    rowData: { type: Object, default: () => {} },
    rownumber: { type: Number, required: true },
    bgColor: { type: String, default: '' },
    textColor: { type: String, default: '' },
  },
  computed: {
    rowStyle() {
      return Object.assign(
        this.bgColor && { backgroundColor: this.bgColor },
        this.textColor && { color: this.textColor },
      );
    },
  },
  render() {
    const injected = { row: this.rowData, action: this.rowAction };
    const slotted = flattenColumns(this.$slots.default ? this.$slots.default() : [])
      .map(vnode => cloneVNode(vnode, injected));

    const children = [];
    if (this.allowSelection) {
      children.push(h(DataTableColumn, {
        rownumber: this.rownumber,
        name: 'selectRow',
        align: 'centered',
        selectable: true,
        ...injected,
      }));
    }
    children.push(...slotted);

    return h('tr', {
      class: ['table-row has-text-weight-medium is-uppercase', {
        'table-row--fade': this.rowData.fadeEffect,
        'table-row--hover': this.rowAction,
      }],
      style: this.rowStyle,
    }, children);
  },
};
</script>

<style lang="scss">

.table-row{
  font-size: $size-10;
  font-weight: $weight-medium;
  &:nth-child(odd) {
    background-color: $grey-solitude;
  }
  &--fade{
    animation-name: fadeInOut;
    animation-duration: 2s;
    animation-timing-function: linear;
    animation-fill-mode: both;
  }

  &--hover:hover{
    background-color: $cultured;
  }

  @keyframes fadeInOut {
    0%,100% {
      background-color: $grey-solitude;
    }
    30%, 80% {
      background-color: $frangipani;
    }
  }
}

</style>
